<div>
  <div class="chart-wrapper">
    @if (projectAllocationChartData) {
    <ngx-charts-bar-vertical-stacked
      [results]="projectAllocationChartData"
      [tooltipTemplate]="tooltipTemplate"
      [xAxis]="true"
      [yAxis]="true"
      [yAxisTickFormatting]="yAxisTickFormatting"
      [gradient]="false"
      [legend]="true"
      [showXAxisLabel]="true"
      [showYAxisLabel]="true"
      xAxisLabel="Project Owner"
      yAxisLabel="Project Count"
      [barPadding]="projectAllocationChartData?.length > 1 ? 8 : 700"
      [scheme]="colorScheme"
      [autoScale]="true"
      (select)="onSelect($event)">
      <ng-template #tooltipTemplate let-model="model">
        <div>
          <div>{{ model.series }}</div>
          <div>{{ model.fullName }}</div>
          <div>{{ model.value }} Project</div>
        </div>
      </ng-template>
    </ngx-charts-bar-vertical-stacked>
    }
  </div>
  <div class="section-title">Project Allocation</div>
</div>
